<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <div class="card rounded-5 p-3 border">
            <div class="card-body form-style">
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.name}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="name"
                    v-model="menu.name"
                    v-validate="'required|max:300'"
                    maxlength="300"
                    class="form-control"
                    :class="{'input': true, 'is-danger': errors.has('name') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.name"
                  />
                  <i v-show="errors.has('name')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('name')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_valid_name}}</span>
                </div>

                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.store}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="custom-select-dd">
                    <select
                      class="form-control"
                      v-model="menu.store_id"
                      v-validate="'required'"
                      name="store_id"
                      :disabled=" ( menu.id != null && menu.id) "
                    >
                      <option value>{{$lang.messages.select_store}}</option>
                      <option
                        v-for="store in stores"
                        :key="store.id"
                        :value="store.id"
                      >{{store.name}}</option>
                    </select>

                    <i v-show="errors.has('store_id')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('store_id')"
                      class="help is-danger"
                    >{{$lang.messages.please_select_store}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 text-right">
          <button
            type="button"
            class="btn btn-primary mr-3"
            id="save-btn"
            @click="validateForm()"
          >{{$lang.messages.save_btn_text}}</button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="$router.go(-1)"
          >{{$lang.messages.cancel_btn_text}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
export default {
  name: "AddMenu",
  data() {
    return {
      menu: {
        id: null,
        name: "",
        store_id: ""
      },
      stores: []
    };
  },
  methods: {
    getStores() {
      this.stores = [];
      this.$api
        .getAPI({
          _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          this.stores = res.list;
        });
    },
    details(id) {
      this.menu = {};

      this.$api
        .getAPI({
          _action: "/menuApp/detail/" + id
        })
        .then(res => {
          this.menu = res;
        });
    },
    save() {
      this.$api
        .postAPI({
          _action: "/menuApp/",
          _body: this.menu,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });

          router.push("/settings");
        })
        .catch(e => {});
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    }
  },
  mounted() {
    this.getStores();
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>